import { render } from "./LevelUpDialog.vue?vue&type=template&id=2c68ab2f&scoped=true"
import script from "./LevelUpDialog.vue?vue&type=script&lang=js"
export * from "./LevelUpDialog.vue?vue&type=script&lang=js"

import "./LevelUpDialog.vue?vue&type=style&index=0&id=2c68ab2f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c68ab2f"]])

export default __exports__